export const header = 'Recent past reminders';
export const subHeader =
  'Here you can manage posts that may still require posting from your mobile';
